/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationCollection.types.tsx';
import { updateCollection } from './updateCollection.tsx';

export const expandSectionForSelectedCollection =
	(): Action<State, Props> =>
	async ({ dispatch }, { activeCollectionUUID, onSuccess }) => {
		if (activeCollectionUUID) {
			dispatch(updateCollection(activeCollectionUUID, { isExpanded: true }));
			onSuccess?.('expandSectionForSelectedCollection');
		}
	};
